import { useSelector } from "react-redux";
import BuyerLayout from "../components/Layout";
import Breadcrumb from "../../SharedComponents/components/Breadcrumb/Breadcrumb";
import BaseButton from "../../SharedComponents/components/Buttons/BaseButton";
import { useNavigate } from "react-router-dom";
import { ButtonVariantEnum } from "../../SharedComponents/utils/enums/ButtonVariantEnum";
import ButtonDownArrowIconSVG from "../assets/icons/svg/ButtonDownArrowIconSVG";
import SingleUserCarRequestsComponent from "../components/AllRequestsComponents/SingleUserCarRequestsComponent";

const AllRequestsPage = () => {
    const navigate = useNavigate();

    const cars = useSelector((state) => state.userCars.cars);

    const breadcrumbs = [
        { title: "Početak", href: "/" },
        { title: "Svi zahtevi" }
    ];

    const GetBreadcrumbEndComponent = () => {
        return (
            <BaseButton
                onClick={() => navigate('/order-part')}
                variant={ButtonVariantEnum.BLACK}
                text={"Pošalji zahtev"}
                IconComponent={ButtonDownArrowIconSVG}
            />
        );
    };

    return (
        <BuyerLayout>
            <Breadcrumb
                title={"Svi zahtevi"}
                breadcrumbs={breadcrumbs}
                EndComponent={GetBreadcrumbEndComponent}
            />

            <div style={styles.mainContainer}>
                {cars.map((car, index) => {
                    return (
                        <SingleUserCarRequestsComponent
                            key={index}
                            car={car}
                        />
                    );
                })}
            </div>

        </BuyerLayout>
    );
};

export default AllRequestsPage;

const styles = {
    mainContainer: {
        marginTop: 40,
        display: 'flex',
        flexDirection: 'column',
        gap: 40
    }
}